import logo from './logo.svg';
import './App.css';
import Model from './components/Model';

function App() {
  return (
    <div className="App">
      <Model />
    </div>
  );
}

export default App;
